import { useNavigate } from "react-router-dom";
import { useUser } from "contexts/UserContext";

// CTSNAP.js
function CTSNAPInstance(useToken = false, useUserId = true) {
  const { user } = useUser();
  const navigate = useNavigate();
  return new CTSNAP({
    user: user,
    useUserId: useUserId,
    useToken: useToken,
    navigate: navigate,
  });
}

class CTSNAP {
  constructor({
    useUserId = true,
    useToken = false,
    user = null,
    navigate: Navigate = null,
  } = {}) {
    this.useToken = useToken;
    this.useUserId = useUserId;
    this.user = user;
    this.url = "";
    this.navigate = Navigate;
    this.params = {};
    this.bodyParams = {};
    this.metodo = "GET";
    this.body = {};
    this.headers = {
      "Content-Type": "application/json",
    };
  }

  init() {
    this.url = "";
    this.params = {};
    this.bodyParams = {};
    this.metodo = "GET";
    this.body = {};
    this.headers = {
      "Content-Type": "application/json",
    };
  }
  setMetodo(metodo) {
    this.metodo = metodo.toUpperCase();
  }

  setParam(key, value) {
    this.params[key] = value; //encodeURIComponent(value);
  }

  setParamBody(key, value) {
    this.bodyParams[key] = value;
  }

  getParamBody() {
    return { ...this.bodyParams };
  }

  setFuncion(func) {
    if (!func.startsWith("/")) {
      func = "/" + func;
    }
    this.url = func;
  }

  // buildUrl() {
  //   const baseUrl = window.location.origin; //"https://192.168.2.16:4433";

  //   const url = new URL(this.url, baseUrl);

  //   if (this.useUserId && this.user?.id) {
  //     this.params["user_id"] = this.user.id;
  //   }

  //   for (const [key, value] of Object.entries(this.params)) {
  //     url.searchParams.append(key, value);
  //   }

  //   return url.toString();
  // }

  buildUrl() {
    let baseUrl;

    if (process.env.REACT_APP_API_URL) {
      // En producción: agregar /api al path
      baseUrl =
        window.location.origin + process.env.REACT_APP_API_URL + this.url;
    } else {
      // En desarrollo: usar proxy normal
      baseUrl = window.location.origin + this.url;
    }

    // No usar new URL(), construir directamente
    const url = new URL(baseUrl);

    if (this.useUserId && this.user?.id) {
      url.searchParams.append("user_id", this.user.id);
    }

    for (const [key, value] of Object.entries(this.params)) {
      url.searchParams.append(key, value);
    }

    return url.toString();
  }

  prepareHeaders() {
    if (this.useToken) {
      if (this.useToken && this.user?.token) {
        this.headers["Authorization"] = `Bearer ${this.user.token}`;
      }
    }

    return this.headers;
  }

  async fetchData(additionalBody = null) {
    const url = this.buildUrl();
    const options = {
      method: this.metodo,
      headers: this.prepareHeaders(),
    };

    if (this.metodo === "POST") {
      this.body = { ...this.bodyParams, ...additionalBody };
      options.body = JSON.stringify(this.body);
    }
    localStorage.setItem("lastActivity", Date.now().toString());
    try {
      const response = await fetch(url, options);

      if (response.status >= 500 && response.status < 600) {
        throw new Error(`Error del servidor: ${response.status} ${response.statusText}`);
      }
      
      const contentType = response.headers.get("Content-Type");
      let data = null;


      if (contentType?.includes("application/json")) {
        data = await response.json();
      }

      // ✅ Caso especial: 401 con JSON y Error.ID > 0
      if (response.status === 401 && data?.Error?.ID > 0) {
        return data; // devolvemos todo el JSON tal cual
      }

      if (response.status === 401 || response.status === 403) {
        if (this.logout) this.logout();
        if (this.navigate) this.navigate("/login");
        throw new Error("Sesión caducada");
      }

      const rawToken = response.headers.get("Authorization");
      let token = null;
      if (rawToken?.startsWith("Bearer ")) {
        token = rawToken.split(" ")[1];
      }

      if (data) {
        // 🔍 Verifica si hay un error con nivell = 999
        if (data?.Error?.NIVELL === 999) {
          alert("Error" + data.error?.TXT);
          if (this.navigate) {
            this.navigate("/login"); // Navegamos a login al cerrar el mensaje
          }
          return null;
        }

        // Si token existe, lo añadimos al JSON
        if (token) {
          return { ...data, token: token };
        } else {
          return data;
        }
      } else {
        return await response.text();
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      throw error;
    }
  }
}

export { CTSNAP, CTSNAPInstance };
